import React, { useState } from "react";
import { toast } from "react-toastify";
import { useAddBankInfoMutation } from "../../../features/api/bankinfoApi";

const CreateBankInfo = () => {
  const [addBankInfo] = useAddBankInfoMutation();

  const [bankName, setBankName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [accName, setAccName] = useState("");
  const [accNo, setAccNo] = useState("");
  const [BraRouNum, setBraRouNum] = useState("");
  const [BankLoct, setBankLoct] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newBankInfo = {
      bankName,
      branchName,
      accName,
      accNo,
      BraRouNum,
      BankLoct,
    };
    try {
      const result = await addBankInfo(newBankInfo);

      if (result) {
        toast.success("Added Successful...!!!");
        setBankName("");
        setBranchName("");
        setAccName("");
        setAccNo("");
        setBraRouNum("");
        setBankLoct("");
      }
    } catch (error) {
      toast.error(error);
    }
  };
  return (
    <div className="w-full max-w-[1280px] mx-auto p-6 md:px-auto h-[90vh] overflow-auto">
      <h1 className="uppercase font-bold">create bank info</h1>
      <div className="py-4">
        <form className="">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            <div>
              <label>Bank Name: </label>
              <input
                type="text"
                value={bankName}
                onChange={(e) => setBankName(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>
            <div>
              <label>Branch Name: </label>
              <input
                type="text"
                value={branchName}
                onChange={(e) => setBranchName(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>
            <div>
              <label>Account Name: </label>
              <input
                type="text"
                value={accName}
                onChange={(e) => setAccName(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>
            <div>
              <label>Account No.: </label>
              <input
                type="text"
                value={accNo}
                onChange={(e) => setAccNo(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>
            <div>
              <label>Branch Routing Number: </label>
              <input
                type="text"
                value={BraRouNum}
                onChange={(e) => setBraRouNum(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>
            <div>
              <label>Bank Location: </label>
              <input
                type="text"
                value={BankLoct}
                onChange={(e) => setBankLoct(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>
          </div>
          <button
            onClick={handleSubmit}
            className="px-2 py-1 bg-green-500 text-white font-bold rounded mt-4"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateBankInfo;